(function () {
  'use strict';

  function pad(value) {
    return String(value).padStart(2, '0');
  }

  function initGallery(section) {
    var mainImage = section.querySelector('[data-tfd-main-image]');
    var thumbs = section.querySelectorAll('[data-tfd-thumb]');
    if (!mainImage || !thumbs.length) return;

    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var image = thumb.getAttribute('data-image');
        var srcset = thumb.getAttribute('data-srcset');
        var alt = thumb.getAttribute('data-alt') || '';
        if (!image) return;

        mainImage.classList.add('is-changing');

        window.setTimeout(function () {
          mainImage.setAttribute('src', image);
          if (srcset) mainImage.setAttribute('srcset', srcset);
          mainImage.setAttribute('alt', alt);
          mainImage.classList.remove('is-changing');
        }, 160);

        thumbs.forEach(function (button) {
          button.classList.remove('is-active');
          button.setAttribute('aria-selected', 'false');
        });

        thumb.classList.add('is-active');
        thumb.setAttribute('aria-selected', 'true');
      });
    });
  }

  function getTarget(section) {
    var mode = section.getAttribute('data-countdown-mode');

    if (mode === 'daily') {
      var now = new Date();
      var target = new Date(now);
      target.setHours(24, 0, 0, 0);
      return target.getTime();
    }

    if (mode === 'fixed') {
      var fixedDate = section.getAttribute('data-end-date');
      var parsed = new Date(fixedDate).getTime();
      return Number.isNaN(parsed) ? null : parsed;
    }

    return null;
  }

  function initCountdown(section) {
    var hourNode = section.querySelector('[data-tfd-hours]');
    var minuteNode = section.querySelector('[data-tfd-minutes]');
    var secondNode = section.querySelector('[data-tfd-seconds]');
    if (!hourNode || !minuteNode || !secondNode) return;

    var target = getTarget(section);
    if (!target) return;

    function render() {
      var now = Date.now();
      var diff = Math.max(0, target - now);

      if (diff === 0 && section.getAttribute('data-countdown-mode') === 'daily') {
        target = getTarget(section);
        diff = Math.max(0, target - now);
      }

      var totalSeconds = Math.floor(diff / 1000);
      var hours = Math.floor(totalSeconds / 3600);
      var minutes = Math.floor((totalSeconds % 3600) / 60);
      var seconds = Math.floor(totalSeconds % 60);

      hourNode.textContent = pad(hours);
      minuteNode.textContent = pad(minutes);
      secondNode.textContent = pad(seconds);
    }

    render();
    section._tfdTimer = window.setInterval(render, 1000);
  }

  function initReveal(section) {
    if (!section.classList.contains('tfd--animate')) {
      section.classList.add('is-visible');
      return;
    }

    if (!('IntersectionObserver' in window)) {
      section.classList.add('is-visible');
      return;
    }

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          section.classList.add('is-visible');
          observer.disconnect();
        }
      });
    }, { threshold: 0.15 });

    observer.observe(section);
  }

  function initSection(section) {
    if (!section || section.dataset.tfdReady === 'true') return;
    section.dataset.tfdReady = 'true';
    initGallery(section);
    initCountdown(section);
    initReveal(section);
  }

  function initAll(root) {
    (root || document).querySelectorAll('[data-tfd]').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll(document);
    });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });

  document.addEventListener('shopify:section:unload', function (event) {
    var section = event.target.querySelector('[data-tfd]');
    if (section && section._tfdTimer) window.clearInterval(section._tfdTimer);
  });
})();
